<template>
	<div class="d-flex align-items-center">
		<b-button variant="outline-light" class="px-3 d-flex align-items-center text-dark" :pressed="path.length === 0" @click="$emit('navigate', -1)">
			<component :is="getLucideIcon('Home')" color="#06263E" :size="16" :stroke-width="2.5" class="mr-2" />
			<span><slot name="root-title" /></span>
		</b-button>
		<div v-for="(folder, index) in path" :key="index" class="d-flex align-items-center" style="gap: 7px">
			<component :is="getLucideIcon('ChevronRight')" color="#06263E" :size="20" :stroke-width="2.5" />
			<b-button
				variant="outline-light"
				class="px-3 d-flex align-items-center text-dark"
				:pressed="index === path.length - 1"
				@click="$emit('navigate', index)"
			>
				<component :is="getLucideIcon('FolderOpen')" color="#06263E" :size="16" :stroke-width="2.5" class="mr-2" />
				<span>
					{{ folder }}
				</span>
			</b-button>
		</div>
	</div>
</template>
<script>
import languageMessages from '@/mixins/languageMessages';
import GlobalMixin from '@/mixins/global.mixin';
import { store } from '@/store';

export default {
	name: 'CustomCrumbBar',
	mixins: [languageMessages, GlobalMixin],
	props: {
		path: {
			type: Array,
			required: true
		}
	}
};
</script>
<style></style>
